function isInFrame() {
    return window.parent !== window;
}

export default isInFrame;


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/InFrame.ts